export const JS_OBJECT_EXPRESSION = 'ObjectExpression' // https://github.com/EricSmekens/jsep/blob/master/packages/object/src/index.js#L4
